import { fetchRequest } from 'src/hooks/useAPIRequest'
import { API_ENDPOINTS } from 'src/routes/routes'

import { LoginResponse } from '../../types'

interface Params {
    id: string
    token: string
}

const loginMultiTenantUser = async ({ id, token }: Params) => {
    return await fetchRequest<LoginResponse>(`${API_ENDPOINTS.LOGIN_ACTIVE_TENANT}?tenant_id=${id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
    })
}

export default loginMultiTenantUser
